module.exports = __webpack_public_path__ + "img/greg-washington-sq.2beae26e.jpg";